import { some, trim } from "lodash";

export interface RenderedSegment {
  kind: "prose" | "code";
  text: string;
}

const FENCE = /^\s*(```|~~~)/;

// 🔴 The prompt editor drops fenced blocks, so fences are cut out and shown verbatim; an unclosed one runs to the end.
export function renderedSegments(text: string): RenderedSegment[] {
  const segments: RenderedSegment[] = [];
  let kind: RenderedSegment["kind"] = "prose";
  let lines: string[] = [];

  const flush = () => {
    if (kind === "code" || some(lines, (line) => trim(line))) {
      segments.push({ kind, text: lines.join("\n") });
    }
    lines = [];
  };

  text.split("\n").forEach((line) => {
    if (FENCE.test(line)) {
      flush();
      kind = kind === "prose" ? "code" : "prose";
      return;
    }
    lines.push(line);
  });
  flush();

  return segments;
}
